import { createSlice } from '@reduxjs/toolkit';

// Deliberately separate from notificationsSlice.js. Sheet 1 Insights are
// cron-produced (twice daily) and capability-scoped per project, so a
// revoked capability must make a card disappear on the very next fetch —
// setItems here REPLACES the array (no notificationsSlice-style
// refreshItems id-merge, which would let a revoked insight survive in
// state until manually evicted).
const insightsSlice = createSlice({
  name: 'insights',
  initialState: {
    items: [],
    status: 'idle',
    // Own transport flag so an insights-fetch failure never blocks the
    // (unrelated) notifications list from rendering, and vice versa.
    transportDown: false,
  },
  reducers: {
    setItems: (state, action) => {
      state.items = action.payload;
    },
    ackItem: (state, action) => {
      const item = state.items.find((insight) => insight.id === action.payload);
      if (item) item.isUnread = false;
    },
    ackAllItems: (state) => {
      state.items.forEach((item) => {
        item.isUnread = false;
      });
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setTransportDown: (state, action) => {
      state.transportDown = action.payload;
    },
  },
});

export const { setItems, ackItem, ackAllItems, setStatus, setTransportDown } = insightsSlice.actions;

export default insightsSlice.reducer;
